import {useMemo} from "react";
import {useTheme} from "@emotion/react";

import {IComparisonTableStyleDefaults} from "../types/IComparisonTableStyleDefaults";

export const useThemeDefaults = (): IComparisonTableStyleDefaults => {
    const theme = useTheme();

    return useMemo(() => {
        return {
            headerIcons: {
                size: "2.4",
                fill: theme.colors.gray["700"]
            }
        };
    }, []);
};
import {useMemo} from "react";
import {useTheme} from "@emotion/react";

import {IComparisonTableStyleDefaults} from "../types/IComparisonTableStyleDefaults";

export const useThemeDefaults = (): IComparisonTableStyleDefaults => {
    const theme = useTheme();

    return useMemo(() => {
        return {
            headerIcons: {
                size: "2.4",
                fill: theme.colors.gray["700"]
            }
        };
    }, []);
};
